// extracted by mini-css-extract-plugin
module.exports = {"table":"tenantInfoDialog_table__12csW","tips":"tenantInfoDialog_tips__r9aIH"};